export const setupVideoAutopause = (emblaApi) => {
    const slides = emblaApi.slideNodes();
    let activeVideoSource = null; 
    let videoLockInterval = null;

    // Helper: Para a automação e liga o "Guarda-Costas"
    const stopSliderAutomation = () => {
        if (videoLockInterval) return; 

        if (emblaApi.plugins().autoplay) emblaApi.plugins().autoplay.stop();
        if (emblaApi.plugins().autoScroll) emblaApi.plugins().autoScroll.stop();
        
        videoLockInterval = setInterval(() => {
            if (emblaApi.plugins().autoplay) emblaApi.plugins().autoplay.stop();
            if (emblaApi.plugins().autoScroll) emblaApi.plugins().autoScroll.stop();
        }, 100);
    };

    // Helper: Retoma a automação
    const resumeSliderAutomation = () => {
        if (videoLockInterval) {
            clearInterval(videoLockInterval);
            videoLockInterval = null;
        }
        if (emblaApi.plugins().autoplay) emblaApi.plugins().autoplay.play();
        if (emblaApi.plugins().autoScroll) emblaApi.plugins().autoScroll.play();
    };

    // Helper: Pausa todos os vídeos exceto a origem atual
    const pauseAllOtherVideos = (currentSource) => {
        slides.forEach((slide) => {
            const videoTags = slide.querySelectorAll('video');
            videoTags.forEach((video) => {
                const isBackgroundVideo = video.hasAttribute('autoplay') && (video.muted || video.hasAttribute('muted'));
                if (!isBackgroundVideo && video !== currentSource && !video.paused) {
                    video.pause();
                }
            });

            const iframes = slide.querySelectorAll('iframe');
            iframes.forEach((iframe) => {
                if (iframe.contentWindow !== currentSource) {
                    iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo' }), '*'); 
                    iframe.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*'); 
                }
            });
        });
    };

    // --- SETUP INICIAL ---
    slides.forEach((slide) => {
        const iframes = slide.querySelectorAll('iframe');
        iframes.forEach((iframe) => {
            let src = iframe.getAttribute('src');
            if (src && (src.includes('youtube.com') || src.includes('youtu.be')) && !src.includes('enablejsapi=1')) {
                src += (src.includes('?') ? '&' : '?') + 'enablejsapi=1';
                iframe.setAttribute('src', src);
            }

            const startListening = () => {
                if (src.includes('youtube') || src.includes('youtu.be')) {
                    iframe.contentWindow.postMessage(JSON.stringify({ event: 'listening' }), '*');
                } else if (src.includes('vimeo')) {
                    iframe.contentWindow.postMessage(JSON.stringify({ method: 'addEventListener', value: 'play' }), '*');
                    iframe.contentWindow.postMessage(JSON.stringify({ method: 'addEventListener', value: 'pause' }), '*');
                    iframe.contentWindow.postMessage(JSON.stringify({ method: 'addEventListener', value: 'finish' }), '*');
                }
            };
            startListening();
            iframe.addEventListener('load', startListening);
        });

        const videoTags = slide.querySelectorAll('video');
        videoTags.forEach((video) => {
            const isBackgroundVideo = video.hasAttribute('autoplay') && (video.muted || video.hasAttribute('muted'));
            if (!isBackgroundVideo) {
                video.addEventListener('play', (e) => {
                    activeVideoSource = e.target; 
                    pauseAllOtherVideos(activeVideoSource); 
                    stopSliderAutomation();
                });
                video.addEventListener('pause', (e) => {
                    if (activeVideoSource === e.target) resumeSliderAutomation();
                });
                video.addEventListener('ended', (e) => {
                    if (activeVideoSource === e.target) resumeSliderAutomation();
                });
            }
        });
    });

    // --- LISTENERS GLOBAIS ---
    window.addEventListener('message', (event) => {
        try {
            const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;

            if (data.event === 'infoDelivery' && data.info && data.info.playerState !== undefined) {
                const state = data.info.playerState;
                if (state === 1 || state === 3) {
                    activeVideoSource = event.source; 
                    pauseAllOtherVideos(activeVideoSource);
                    stopSliderAutomation(); 
                }
                else if (state === 2 || state === 0) {
                    if (activeVideoSource === event.source) resumeSliderAutomation(); 
                }
            }

            if (data.event === 'play') {
                activeVideoSource = event.source; 
                pauseAllOtherVideos(activeVideoSource);
                stopSliderAutomation();
            }
            else if (data.event === 'pause' || data.event === 'finish') {
                if (activeVideoSource === event.source) resumeSliderAutomation();
            }
        } catch (e) {}
    });

    // --- CORTE AO MUDAR SLIDE ---
    emblaApi.on('select', () => {
        const currentIndex = emblaApi.selectedScrollSnap();
        slides.forEach((slide, index) => {
            if (index !== currentIndex) {
                const videoTags = slide.querySelectorAll('video');
                videoTags.forEach((video) => {
                    const isBackgroundVideo = video.hasAttribute('autoplay') && (video.muted || video.hasAttribute('muted'));
                    if (!video.paused && !isBackgroundVideo) video.pause();
                });

                const iframes = slide.querySelectorAll('iframe');
                iframes.forEach((iframe) => {
                    iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo' }), '*'); 
                    iframe.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*'); 
                });
            } 
        });
    });
};